<template>
  <div class='Box'>

    <el-card class="box-card">

      <div class="div_buttom">
        <el-button size="medium" type="primary" icon="el-icon-back" @click="fallback">返回</el-button>
      </div>

      <el-container>
        <el-aside width="200px">
          <div class="info">
            <el-avatar shape="square" :size="50" :src="infoData.avatar"></el-avatar>
            <div>{{ infoData.name }}</div>
            <div>ID:{{ infoData.id }}</div>
          </div>
        </el-aside>
        <el-main>
          <el-descriptions class="margin-top" :colon="false" :column="5" direction="vertical">
            <el-descriptions-item label="会员状态">
              <span v-if="infoData.vip == 1">已开通</span>
              <span v-else-if="infoData.vip == 0">未开通</span>
              <span v-else-if="infoData.vip == 2">已过期</span>
            </el-descriptions-item>
            <el-descriptions-item label="会员结束时间">
              {{ infoData.vip_expired_at }}
            </el-descriptions-item>
            <el-descriptions-item label="余额(永久)">{{ infoData.balance }}</el-descriptions-item>
            <el-descriptions-item label="余额(赠送)">{{ infoData.free_balance }}</el-descriptions-item>
            <el-descriptions-item label="注册时间">{{ infoData.created_at }}</el-descriptions-item>
            <el-descriptions-item label="渠道昵称">{{ infoData.vip_name }}</el-descriptions-item>
            <el-descriptions-item label="优化师昵称">{{ infoData.optimizer_name }}</el-descriptions-item>
            <el-descriptions-item label="商务名称">{{ infoData.business_name }}</el-descriptions-item>
            <el-descriptions-item label="用户当前所属渠道号">{{ infoData.channel_code }}</el-descriptions-item>
          </el-descriptions>
        </el-main>
      </el-container>

      <el-tabs v-model="activeName" style="margin-left: 30px;" @tab-click="handleClick">

        <el-tab-pane label="订单记录" name="orderList">

          <el-table ref="multipleTable" :data="tableData" tooltip-effect="dark"
                    size="medium"
                    :header-cell-style="{textAlign:'center',background:'#f5f7fa'}" :cell-style="{textAlign:'center'}"
                    style="width: 100%" border v-loading="loading">

            <el-table-column label="id">
              <template slot-scope="scope">{{ scope.row.id }}</template>
            </el-table-column>

            <el-table-column prop="trade_no" label="商户单号">
              <template slot-scope="scope">{{ scope.row.trade_no }}</template>
            </el-table-column>

            <el-table-column prop="payment_order_no" label="交易单号">
              <template slot-scope="scope">{{ scope.row.payment_order_no }}</template>
            </el-table-column>

            <el-table-column prop="type" label="订单类型" width="80">
              <template slot-scope="scope">
                <span v-if="scope.row.type == 1">VIP充值</span>
                <span v-else-if="scope.row.type == 0">普通充值</span>
              </template>
            </el-table-column>

            <el-table-column prop="money" label="总额" width="80">
              <template slot-scope="scope">{{ scope.row.money }}</template>
            </el-table-column>

            <el-table-column prop="recharge_money" label="实付金额" width="80">
              <template slot-scope="scope">{{ scope.row.recharge_money }}</template>
            </el-table-column>

            <el-table-column prop="state" label="订单状态" width="80">
              <template slot-scope="scope">
                <span v-if="scope.row.state == 1"><span style="color: #67C23A;">•</span>已支付</span>
                <span v-else-if="scope.row.state == 0"><span style="color: red;">•</span>未支付</span>
              </template>
            </el-table-column>

            <el-table-column prop="created_at" label="下单时间" width="170">
              <template slot-scope="scope">{{ scope.row.created_at }}</template>
            </el-table-column>

            <el-table-column prop="finistime" label="完成时间" width="170">
              <template slot-scope="scope">{{ scope.row.finistime }}</template>
            </el-table-column>

          </el-table>

          <pagination v-show="total > 0" :total="total" :page.sync="queryParams.pageNo"
                      :limit.sync="queryParams.pageSize" @pagination="getList()"/>

        </el-tab-pane>

        <el-tab-pane label="订阅记录" name="subscriptionList">

          <el-table ref="multipleTable" :data="tableData" tooltip-effect="dark"
                    size="medium"
                    :header-cell-style="{textAlign:'center',background:'#f5f7fa'}" :cell-style="{textAlign:'center'}"
                    style="width: 100%" border v-loading="loading">

            <el-table-column label="id">
              <template slot-scope="scope">{{ scope.row.id }}</template>
            </el-table-column>

            <el-table-column prop="novel_name" label="小说名称">
              <template slot-scope="scope">{{ scope.row.novel_name }}</template>
            </el-table-column>

            <el-table-column prop="novel_name" label="章节">
              <template slot-scope="scope">{{ scope.row.novel_name }}</template>
            </el-table-column>

            <el-table-column prop="amount" label="付费积分">
              <template slot-scope="scope">{{ scope.row.amount }}</template>
            </el-table-column>

            <el-table-column prop="free_amount" label="免费积分">
              <template slot-scope="scope">{{ scope.row.free_amount }}</template>
            </el-table-column>

            <el-table-column prop="vip" label="是否会员消费">
              <template slot-scope="scope">
                <span v-if="scope.row.vip == 1">是</span>
                <span v-else-if="scope.row.vip == 0">否</span>
              </template>
            </el-table-column>

          </el-table>

          <pagination v-show="total > 0" :total="total" :page.sync="queryParams.pageNo"
                      :limit.sync="queryParams.pageSize" @pagination="getList()"/>

        </el-tab-pane>

        <el-tab-pane label="观看记录" name="readList">

          <el-table ref="multipleTable" :data="tableData" tooltip-effect="dark"
                    size="medium"
                    :header-cell-style="{textAlign:'center',background:'#f5f7fa'}" :cell-style="{textAlign:'center'}"
                    style="width: 100%" border v-loading="loading">

            <el-table-column label="id">
              <template slot-scope="scope">{{ scope.row.id }}</template>
            </el-table-column>

            <el-table-column prop="novel_name" label="小说名称">
              <template slot-scope="scope">{{ scope.row.novel_name }}</template>
            </el-table-column>

            <el-table-column prop="novel_chapter_id" label="章节">
              <template slot-scope="scope">{{ scope.row.novel_chapter_id }}</template>
            </el-table-column>

            <el-table-column prop="novel_chapter_name" label="章节名称">
              <template slot-scope="scope">{{ scope.row.novel_chapter_name }}</template>
            </el-table-column>

          </el-table>

          <pagination v-show="total > 0" :total="total" :page.sync="queryParams.pageNo"
                      :limit.sync="queryParams.pageSize" @pagination="getList()"/>

        </el-tab-pane>

        <el-tab-pane label="充值记录" name="topUpList">

          <el-table ref="multipleTable" :data="tableData"
                    size="medium"
                    :header-cell-style="{textAlign:'center',background:'#f5f7fa'}" :cell-style="{textAlign:'center'}"
                    tooltip-effect="dark" style="width: 100%" border v-loading="loading">

            <el-table-column label="id">
              <template slot-scope="scope">{{ scope.row.id }}</template>
            </el-table-column>

            <el-table-column prop="type" label="充值类型">
              <template slot-scope="scope">
                {{scope.row.type_text}}
              </template>
            </el-table-column>

            <el-table-column prop="balance" label="充值积分">
              <template slot-scope="scope">{{ scope.row.balance }}</template>
            </el-table-column>

            <el-table-column prop="free_balance" label="赠送积分">
              <template slot-scope="scope">{{ scope.row.free_balance }}</template>
            </el-table-column>

            <el-table-column prop="remain_free_balance" label="剩余赠送积分">
              <template slot-scope="scope">{{ scope.row.remain_free_balance }}</template>
            </el-table-column>

            <el-table-column prop="free_endtime" label="赠送积分到期时间">
              <template slot-scope="scope">{{ scope.row.free_endtime }}</template>
            </el-table-column>

            <el-table-column prop="vip_starttime" label="会员开始时间">
              <template slot-scope="scope">{{ scope.row.vip_starttime }}</template>
            </el-table-column>

            <el-table-column prop="day" label="会员时长(天)">
              <template slot-scope="scope">{{ scope.row.day }}</template>
            </el-table-column>

            <el-table-column prop="edit_type" label="操作类型">
              <template slot-scope="scope">
                {{ scope.row.edit_type_text }}
              </template>
            </el-table-column>

          </el-table>

          <pagination v-show="total > 0" :total="total" :page.sync="queryParams.pageNo"
                      :limit.sync="queryParams.pageSize" @pagination="getList()"/>

        </el-tab-pane>

      </el-tabs>
    </el-card>
  </div>
</template>

<script>
import {userApi} from "@/api/user";
import {processErrors} from "@/utils/errorHandler";

export default {
  components: {},
  data() {
    return {
      user_id: null,
      SearchFlag: false,
      queryParams: {
        pageNo: 1,
        pageSize: 10,
        type: 1,
      },
      infoData: {},
      tableData: [],
      multipleSelection: [],
      type: 1,
      total: 0,
      activeName: 'orderList',
      loading: false,
    };
  },
  created() {
    this.user_id = this.$route.query.id
    this.getInfo();
    this.getList();
  },
  methods: {

    handleClick(tab, event) {
      this.type = Number(tab.index) + 1;
      this.queryParams.pageNo = 1;
      this.queryParams.pageSize = 10;
      this.total = 0;
      this.getList();
    },
    getInfo() {
      let api = userApi();
      let params = {
        id: this.user_id,
      }
      api.getUserInfo(params).then(res => {
        if (res.code == 0) {
          this.infoData = res.data
        } else {
          processErrors(res);
        }
      }).catch(error => {
        console.error('Error fetching user data:', error);
        this.loading = false;
      });
    },

    getList() {
      this.loading = true;
      let api = userApi();
      this.tableData = [];
      this.queryParams.type = this.type;
      this.queryParams.user_id = this.user_id;
      api.getUserRecords(this.queryParams).then(res => {
        if (res.code == 0) {
          this.tableData = res.data.data
          this.total = res.data.totalCount
        } else {
          processErrors(res);
        }
        this.loading = false;
      }).catch(error => {
        console.error('Error fetching user data:', error);
        this.loading = false;
      });
    },

    fallback() {
      this.$router.push('/user/userList');
    }
  },

  mounted() {

  },
}
</script>
<style lang='scss' scoped>

.el-card__body {
  padding: 0px !important;
}

.btn_left {
  margin-left: 100px;
}

.div_buttom {
  width: 100%;
  display: flex;
  margin-bottom: 20px;
}

.info {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
}
</style>